<template>
  <template v-if="certifications.length > 0">
    <TText size="base" variant="semibold" classes="mb-2" tag="h3">
      {{ $t('views.cottage.characteristics.certifications.title') }}
    </TText>

    <div class="flex flex-col lg:flex-row gap-5 mb-5">
      <template
        v-for="(itemCertification, index) in certifications"
        :key="index"
      >
        <div class="flex items-center">
          <span class="relative inline-block">
            <span class="overflow-hidden block h-9">
              <TLazyimg
                :sources="{
                  url: itemCertification.img,
                }"
                :alt="itemCertification.name"
                classes-img="h-9"
                classes="inline-block"
              />
            </span>
          </span>

          <div class="ml-4 overflow-hidden grow">
            <TText size="base" variant="semibold" clamp="clamp1" classes="mb-0">
              {{ itemCertification.name }}
            </TText>
          </div>
        </div>
      </template>
    </div>
  </template>
</template>

<script setup lang="ts">
import type { CottagePage } from '../../entities/CottagePage'

const { t } = useI18n()

type itemType = {
  features: Pick<CottagePage['features'], 'qualityCertifications'>
}

interface propsInterface {
  item: itemType
}

const props = defineProps<propsInterface>()

type certificationsNamesType =
  | 'quality'
  | 'stars1'
  | 'stars2'
  | 'stars3'
  | 'stars4'
  | 'stars5'

type certificationsType = {
  img: string
  name: string
}

const certificationsList: Record<certificationsNamesType, certificationsType> =
  {
    quality: {
      img: '/__nuxt-public/images/page-content/cottage/certification/quality.png',
      name: t('views.cottage.characteristics.certifications.quality'),
    },
    stars1: {
      img: '/__nuxt-public/images/page-content/cottage/certification/stars1.png',
      name: t('views.cottage.characteristics.certifications.stars', 1),
    },
    stars2: {
      img: '/__nuxt-public/images/page-content/cottage/certification/stars2.png',
      name: t('views.cottage.characteristics.certifications.stars', 2),
    },
    stars3: {
      img: '/__nuxt-public/images/page-content/cottage/certification/stars3.png',
      name: t('views.cottage.characteristics.certifications.stars', 3),
    },
    stars4: {
      img: '/__nuxt-public/images/page-content/cottage/certification/stars4.png',
      name: t('views.cottage.characteristics.certifications.stars', 4),
    },
    stars5: {
      img: '/__nuxt-public/images/page-content/cottage/certification/stars5.png',
      name: t('views.cottage.characteristics.certifications.stars', 5),
    },
  }

const certifications = computed<Array<certificationsType>>(() => {
  if (props.item.features.qualityCertifications.length < 0) {
    return []
  } else {
    const certificationsParsed: Array<certificationsType> =
      props.item.features.qualityCertifications
        .map(item => {
          if (item.id === 'Q-QUALITY') {
            return certificationsList.quality
          } else if (item.id === 'ONE_STAR') {
            return certificationsList.stars1
          } else if (item.id === 'TWO_STARS') {
            return certificationsList.stars2
          } else if (item.id === 'TREE_STARS') {
            return certificationsList.stars3
          } else if (item.id === 'FOUR_STARS') {
            return certificationsList.stars4
          } else if (item.id === 'FIVE_STARS') {
            return certificationsList.stars5
          }
        })
        .filter(notUndefined => notUndefined !== undefined)

    return certificationsParsed
  }
})
</script>
